import React, { Component } from "react";
import "../style/FAQ.css";
import FrogHead3 from "../assets/Frog_Head_4.png";
import FrogHead2 from "../assets/Frog_Head_2.png";
export class Faq extends Component {
  render() {
    return (
      <div id="faqBox">
        <div className="faq-subbox">
          <h1>1. What is NFrogTs?</h1>
          <p>
            NFrogTs is a collection of collectible NFTs, created on Cardano
            blockchain. There is only 5000 tokens and every of them is unique so
            hurry up and grab your NFrogT!
          </p>
          <img src={FrogHead3} className="frog-img" alt="" />
        </div>
        <div className="faq-subbox">
          <h1>2. How can I buy NFrogT?</h1>
          <p>
            You can look for selling offers on our official discord server or
            dedicated discord marketplaces like CardanoNFT or CNFT.
          </p>
        </div>
        <div className="faq-subbox">
          <h1>3. How can I sell/trade my NFrogT?</h1>
          <p>
            You can put ur NFT on sale on CNFT.io marketplace or dedicated
            discord servers (mentioned earlier).
          </p>
        </div>
        <div className="faq-subbox">
          <h1>4. Which wallet can I use to purchase NFrogT?</h1>
          <p>
            NFrogTs are compatible with every Shelly era wallet. You can use
            Daedalus/Yoroi/ADAlite/Nami Wallet.
          </p>
          <h1>NOTICE: DON'T SEND ADA FROM EXCHANGE WALLET!</h1>
          {/*  <img src={FrogHead2} className="frog-img" alt="" />*/}
        </div>
        <div className="faq-subbox">
          <h1>5. What's value of NFrogTs?</h1>
          <p>
            Value is determinated by rarity of colors, gadgets and its amount.
            You can find rarity table of them on our discord & twitter.
          </p>
        </div>
        <div className="faq-subbox">
          <h1>6. What's use case of NFrogTs?</h1>
          <p>
            We plan to create browser game possible to play only for NFrogTs
            owners. Follow us on socials to stay updated with the process.
          </p>
        </div>
      </div>
    );
  }
}

export default Faq;
